import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";

export default function NotFoundPage() {
  const { t, lang } = useI18n();
  return (
    <div className="kv-legal" data-testid="notfound-page">
      <div className="kv-container" style={{ maxWidth: 720, textAlign: "center" }}>
        <h1 className="kv-h1">404</h1>
        <h2 className="kv-h2" style={{ marginTop: "0.5rem" }}>{t("notFound.title")}</h2>
        <p className="kv-body" style={{ marginTop: "0.75rem" }}>{t("notFound.body")}</p>
        <div style={{ marginTop: "1.5rem" }}>
          <Link to={`/${lang}`} className="kv-btn-primary" data-testid="notfound-back">
            {t("notFound.back")}
          </Link>
        </div>
      </div>
    </div>
  );
}
